import { FC, useCallback, useState } from 'react'

import { GetLinkModal } from 'bank-onboarding/src/routes/ApplicationList/components/ApplicationsListTable/components'
import { Applications } from 'commons/types/DTO/bank/alerts/applications'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { SortDirection, Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'
import { AlertsPayload } from '~bank-alerts/types'

import { columns } from './columns'

export const ApplicationsTable: FC = () => {
  const { data, isTableLoading, search, onFilterChange, onPageChange } = useAlertsContext()
  const [openGetLinkModal, setOpenGetLinkModal] = useState(false)
  const [applicationId, setApplicationId] = useState<number | null>(null)

  const {
    form: { applicationsPage, applicationsSize, applicationsSortBy, applicationsSortDesc },
    applicationsTotalCount,
    applications
  } = data

  const showGetLinkModal = useCallback((id: number) => {
    setApplicationId(id)
    setOpenGetLinkModal(true)
  }, [])

  const onClose = useCallback(() => {
    setOpenGetLinkModal(false)
  }, [])

  const handleSort = useCallback(
    (direction: 'DESC' | 'ASC', field: string) => {
      onFilterChange(
        {
          ...search,
          applicationsSortBy: field,
          applicationsSortDesc: direction === 'DESC',
          applicationsPage: 1
        } as Partial<AlertsPayload>,
        'applications'
      )
    },
    [search, onFilterChange]
  )

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'applications')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="Applications" anchor="applications">
      <Layer rounded shadowed stretch>
        {openGetLinkModal && applicationId && <GetLinkModal onClose={onClose} applicationId={applicationId} />}
        <Table<Applications>
          dataQa={TableDataQa.BP_ALERTS_APPLICATIONS}
          columns={columns(showGetLinkModal)}
          dataSource={applications.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('applications')}
          pagination={{
            page: applicationsPage || 1,
            size: applicationsSize || 10,
            onChange: handlePageChange,
            total: applicationsTotalCount
          }}
          sorting={{
            order: [
              {
                field: applicationsSortBy || 'lastModifiedDate',
                direction: applicationsSortDesc ? SortDirection.DESC : SortDirection.ASC
              }
            ],
            onChange: (value) => handleSort(value.direction, value.field)
          }}
        />
      </Layer>
    </PageSection>
  )
}
